import type { Bucket, Currency, TimeWindow } from '../../shared/types';
import { BucketCard } from './BucketCard';

type Props = {
  buckets: Bucket[];
  ccy: Currency;
  win: TimeWindow;
  activeBucket: string | null;
  onBucketClick: (id: string) => void;
};

export function BucketGrid({ buckets, ccy, win, activeBucket, onBucketClick }: Props) {
  const sorted = [...buckets].sort((a, b) => b.value_usd - a.value_usd);
  return (
    <div class="bgrid">
      {sorted.map((b) => (
        <BucketCard
          key={b.id}
          bucket={b}
          ccy={ccy}
          win={win}
          active={activeBucket === b.id}
          dimmed={activeBucket != null && activeBucket !== b.id}
          onClick={() => onBucketClick(b.id)}
        />
      ))}
    </div>
  );
}
